import { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Avatar,
  Box,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import MenuItemLogout from "../pages/MenuItemLogout";

const DashboardNavbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const handleProfileMenuOpen = (event) => {
    setProfileMenuAnchor(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null);
  };

  const handleDashboardClick = () => {
    if (isAuthenticated) {
      
      navigate("/Dashboard");
    } else {
      navigate("/login");
    }
    setDrawerOpen(false);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const getUserInitials = () => {
    if (!user?.name && !user?.username && !user?.email) return "U";
    
   
    const displayName = user.name || user.username || user.email;
    
    return displayName
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };

  const getDisplayName = () => {
    return user?.name || user?.username || user?.email || "User";
  };

  const getDisplayRole = () => {
   
    const role = user?.role || "user";
    return role.charAt(0).toUpperCase() + role.slice(1);
  };


  const drawer = (
    <Box
      sx={{
        width: 280,
        height: "100%",
        backgroundColor: "#F8EEDB",
        display: "flex",
        flexDirection: "column",
      }}
      role="presentation"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 20px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            src="/failogo.jpg"
            alt="Logo"
            style={{ height: "35px", width: "35px", marginRight: "8px" }}
          />
          <Typography
            variant="h6"
            component="span"
            sx={{ color: "black", fontSize: "1.8rem", fontWeight: "bold" }}
          >
            f-
          </Typography>
          <Typography
            variant="h6"
            component="span"
            sx={{
              color: theme.palette.primary.main,
              fontSize: "1.8rem",
              fontWeight: "bold",
            }}
          >
            ai
          </Typography>
          <Typography
            variant="h6"
            component="span"
            sx={{ color: "black", fontSize: "1.8rem" }}
          >
            .in
          </Typography>
        </Box>
        <IconButton onClick={toggleDrawer(false)}>
          <CloseIcon />
        </IconButton>
      </Box>

      <List sx={{ flexGrow: 1, paddingTop: "8px" }}>
      
        <ListItem button onClick={handleDashboardClick}>
          <DashboardIcon sx={{ marginRight: 2 }} />
          <ListItemText primary="Dashboard" />
        </ListItem>

        {isAuthenticated && (
          <>
            <Divider sx={{ margin: "8px 0" }} />

          
            <ListItem 
              button 
              onClick={() => {
                navigate("/accountprofile");
                setDrawerOpen(false);
              }}
            >
              <PersonIcon sx={{ marginRight: 2, color: theme.palette.primary.main }}  />
              <ListItemText primary="My Profile" />
            </ListItem>

           
            <ListItem 
              button 
              onClick={() => {
                setProfileMenuAnchor({});
                setDrawerOpen(false);
              }}
            >
              <LogoutIcon sx={{ marginRight: 2, color: theme.palette.primary.main }}  />
              <ListItemText primary="Account Menu" />
            </ListItem>
          </>
        )}

        {!isAuthenticated && (
          <>
            <Divider sx={{ margin: "8px 0" }} />
            <ListItem
              button
              component={Link}
              to="/login"
              onClick={() => setDrawerOpen(false)}
            >
              <PersonIcon sx={{ marginRight: 2 }} />
              <ListItemText primary="Login" />
            </ListItem>
          </>
        )}
      </List>

     
      {isAuthenticated && user && (
        <Box
          sx={{
            padding: "16px",
            borderTop: "1px solid #e0e0e0",
            backgroundColor: "#f5f5f5",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              sx={{
                bgcolor: theme.palette.primary.main,
                width: 32,
                height: 32,
                fontSize: "0.875rem",
              }}
              src={user.profilePicture}
            >
              {getUserInitials()}
            </Avatar>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {getDisplayName()}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {getDisplayRole()}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#F8EEDB",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          zIndex: 999,
        }}
      >
        <Toolbar sx={{ minHeight: { xs: "64px", sm: "70px" } }}>
          {/* Logo */}
          <Link
            to="/Dashboard"
            style={{
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", padding: "4px" }}>
              <img
                src="/failogo.jpg"
                alt="Logo"
                style={{
                  height: isMobile ? "40px" : "50px",
                  width: isMobile ? "40px" : "50px",
                  marginRight: "10px",
                }}
              />
              <Typography
                variant="h6"
                component="span"
                sx={{
                  color: "black",
                  fontSize: isMobile ? "1.8rem" : "2.5rem",
                  fontWeight: "300",
                }}
              >
                f-
              </Typography>
              <Typography
                variant="h6"
                component="span"
                sx={{
                  color: theme.palette.primary.main,
                  fontSize: isMobile ? "1.8rem" : "2rem",
                  fontWeight: "300",
                }}
              >
                ai
              </Typography>
              <Typography
                variant="h6"
                component="span"
                sx={{
                  color: "black",
                  fontSize: isMobile ? "1.8rem" : "2rem",
                  fontWeight: "300",
                }}
              >
                .in
              </Typography>
            </Box>
          </Link>

          <Box sx={{ flexGrow: 1 }} />

          {isMobile ? (
            
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
          ) : (
         
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                width: "100%",
              }}
            >
             
              <Button
                color="inherit"
                startIcon={<DashboardIcon />}
                onClick={handleDashboardClick}
                sx={{
                  marginRight: "70%",
                  marginLeft: "5%",
                  color: "black",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.1)",
                  },
                }}
              >
                Dashboard
              </Button>

              {isAuthenticated ? (
                
                <>
                  <IconButton
                    onClick={handleProfileMenuOpen}
                    size="small"
                    sx={{
                      border: `2px solid ${theme.palette.primary.main}`,
                      padding: "4px",
                      marginRight: "5%",
                    }}
                  >
                    <Avatar
                      sx={{
                        bgcolor: theme.palette.primary.main,
                        width: 32,
                        height: 32,
                        fontSize: "0.875rem",
                      }}
                      src={user?.profilePicture}
                    >
                      {getUserInitials()}
                    </Avatar>
                  </IconButton>
                </>
              ) : (
                
                <Button
                  color="inherit"
                  component={Link}
                  to="/login"
                  sx={{
                    color: "black",
                    "&:hover": {
                      backgroundColor: "rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  Login
                </Button>
              )}
            </Box>
          )}
        </Toolbar>
      </AppBar>

     
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
      >
        {drawer}
      </Drawer>

   
      <MenuItemLogout
        anchorEl={profileMenuAnchor}
        handleClose={handleProfileMenuClose}
      />
    </>
  );
};

export default DashboardNavbar;